import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { generateMetadata, getRouter } from "../../routing/utils/index.js";
import * as pkg from "react-helmet-async";
// @ts-ignore
const { Helmet } = pkg.default || pkg;
/**
 * App component that represent the entry point of the application
 */
export const Component = ({ router: AppRouter, children = undefined, }) => {
    // Return children if they exist
    if (children)
        return children;
    // Otherwise, get the router and return it
    const Router = getRouter(AppRouter);
    return _jsx(Router, {});
};
/**
 * Page component that defines title and description to a page
 */
export const PageToRender = ({ page, data }) => {
    // Get the page component
    const Page = page.render;
    // Get the page props
    const props = data.props || {};
    // Generate meta tags
    const metaTags = React.useMemo(() => {
        return generateMetadata(page.metadata);
    }, []);
    return (_jsxs(React.Fragment, { children: [_jsxs(Helmet, { children: [metaTags.map((meta) => meta), _jsx("meta", { name: "description", content: page.description }), _jsx("title", { children: page.title })] }), _jsx(Page, { ...props })] }));
};
/**
 * Error fallback component that will be displayed if an error occurs
 */
export class ErrorBoundary extends React.Component {
    state = { hasError: false, error: null, info: null };
    componentDidCatch(error, info) {
        this.setState({ hasError: true, error, info });
    }
    render() {
        const { error, info } = this.state;
        if (this.state.hasError) {
            return _jsx(ErrorFallbackComponent, { error: error, info: info });
        }
        // @ts-ignore
        return this.props.children;
    }
}
/**
 * Error fallback component that will be displayed if an error occurs
 */
const ErrorFallbackComponent = ({ error, info }) => {
    console.log({ error, info });
    return (_jsx("div", { style: {
            width: "calc(100% - 80px)",
            height: "calc(100vh - 80px)",
            padding: "40px",
            backgroundColor: "#fff",
        }, children: _jsxs("div", { children: [_jsx("h1", { style: { fontSize: "2rem" }, children: "Something went wrong" }), _jsx("p", { children: error.toString() }), _jsx("div", { style: {
                        width: "100%",
                        height: "auto",
                        borderRadius: 10,
                        padding: "20px",
                        marginTop: "10px",
                        backgroundColor: "#f0f0f0",
                    }, children: _jsx("p", { children: info.componentStack }) })] }) }));
};
